import { Platform } from 'react-native';

// AppKit handles keyboard, Edit-menu, and contextual-menu Paste through the
// same TextInput event. Only composers with an attachment handler opt in.
export function macComposerPasteProps(onPasteFiles) {
  if (Platform.OS !== 'macos' || typeof onPasteFiles !== 'function') return {};
  return {
    pastedTypes: ['string', 'fileUrl', 'image'],
    onPaste: (event) => {
      const files = event?.nativeEvent?.dataTransfer?.files;
      if (files?.length) return onPasteFiles(files);
    },
  };
}
